export default [
  // Web conform routes
  {
    path: "/impressum",
    name: "Impressum",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/Impressum.vue"),
  },
  {
    path: "/datenschutz",
    name: "Datenschutz",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/Datenschutz.vue"),
  },
  // Rollenverwaltung
  {
    path: "/rollenverwaltung",
    name: "rollenverwaltung",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Rollenverwaltung.vue"),
  },
  {
    path: "/tools/sysadmin/rights",
    name: "rights",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/rights.vue"),
  },
  // REDIRECT EVERYTTHING
  {
    path: "/redirect/:routeName",
    name: "redirection",
    component: () => import(/* webpackChunkName: "redirection" */ "@/views/redirection/redirection.vue"),
  },
  // PLAYGROUND
  {
    path: "/playground",
    name: "Playground",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Playground.vue"),
  },
  // TIMETRACKER LIFESAVER <3
  {
    path: "/timetrackeradmin",
    name: "timetrackerAdmin",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/timetracker/timetracker.vue"),
  },
  // Contest Routes
  {
    path: "/wheel",
    name: "spinningWheel",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import("@/views/einmalig/competitions/spinningWheel/spinningWheel.vue"),
  },
  {
    path: "/olma/:video",
    name: "olmaVideo",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import("@/views/einmalig/olma/video.vue"),
  },
  {
    path: "/allianz",
    meta: { navbarTitle: "Allianz" },
    name: "allianzAssociation",
    component: () => import("@/views/einmalig/randomDeprecatedStuff/allianzAssociation.vue"),
  },
  {
    path: "/einstein/contest",
    name: "EinsteinSaunaContest",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/competitions/einsteinSaunaContest.vue"),
  },
  {
    path: "/einstein/contest/admin/list",
    name: "EinsteinSaunaContestAdminList",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/competitions/einsteinSaunaContestAdminList.vue"),
  },
  // WCF PARTY
  {
    path: "/party",
    name: "partyForm",
    meta: {
      hideBottomNavigation: true,
      hideAppBar: true,
      fullWidth: true,
    },
    component: () => import("@/views/event/partyForm.vue"),
  },
  // ALIBEY ROUTES
  {
    path: "/alibey",
    name: "AliBey",
    meta: { navbarTitle: "AliBey", hideAppBar: true, hideBottomNavigation: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "aliBey" */ "@/views/aliBey/aliBey.vue"),
  },
  {
    path: "/alibey/booking",
    name: "AliBeyBooking",
    meta: { navbarTitle: "AliBey", hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "aliBey" */ "@/views/aliBey/aliBeyBooking.vue"),
  },
  {
    path: "/alibey/edit",
    meta: { hideBottomNavigation: true, hideAppBar: false },
    name: "AlibeyEditor",
    component: () => import(/* webpackChunkName: "aliBey" */ "@/views/aliBey/aliBeyEditor.vue"),
  },
  // BIKE SHOP
  /*{
    name: "BikeShop",
    path: "/bikes",
    meta: { hideBottomNavigation: true, hideAppBar: true },
    component: () => import("../views/singleUseViews/Bike/BikeShop.vue"),
    children: [
      {
        name: "BikeOwnOrders",
        path: "orders",
        meta: { hideBottomNavigation: true, hideAppBar: true },
        component: () => import("../views/singleUseViews/Bike/BikeOwnOrders.vue"),
        childen: [],
      },
    ],
  },
  {
    name: "BikeAdminOrders",
    path: "/bikes/orders/admin",
    meta: { hideBottomNavigation: true, hideAppBar: true },
    component: () => import("../views/singleUseViews/Bike/BikeAdminOrders.vue"),
    childen: [],
  },*/
  // SLIM ME
  {
    path: "/slimme/dashboard",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/scams/slimMeView.vue"),
  },
  // OAFF - Openair Frauenfeld
  {
    path: "/oaff",
    name: "oaff",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/randomDeprecatedStuff/oaff.vue"),
  },
  // Report Problem Form
  {
    path: "/intern/report/dashboard",
    name: "viewProblem",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/reportProblemForm/viewProblem.vue"),
  },
  {
    path: "/intern/report",
    name: "reportProblem",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/reportProblemForm/reportProblem.vue"),
  },
  // Displays managed by Roody (CENTERDISPLAYS)
  {
    path: "/centerdisplay/view/:id",
    name: "fitnessCenterDisplay",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/displaysDeprecated/fitnessCenterDisplay.vue"),
  },
  {
    path: "/centerdisplay",
    name: "fitnessCenterDisplay",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/displaysDeprecated/fitnessCenterDisplay.vue"),
  },
  // COVID 19 ROUTES
  {
    path: "/covidcerts/archive",
    name: "Covid_archive",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Covid_archive.vue"),
  },
  {
    path: "/covidcerts",
    name: "Covid_check",
    component: () => import(/* webpackChunkName: "admin" */ "@/views/admin/Covid_check.vue"),
  },
  // COVID TIMESTOP NOT ACTUAL TIMESTOPS!
  {
    path: "/timestopcovid-19",
    name: "Timestop",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/covid19/Timestop.vue"),
  },
  // HELSANA CAMPAIGN
  {
    path: "/helsana",
    name: "Helsana",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/competitions/helsana.vue"),
  },
  // Raspberry Pi Sensor
  {
    path: "/sensordaten",
    name: "Sensordaten",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/randomDeprecatedStuff/Sensordaten.vue"),
  },
  // ANAMNESE AND WORKOUT RATINGS (REFACTOR THIS PLEASE)
  {
    path: "/bewerten/trainingsplan/:plan_id",
    name: "RateWorkouts",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/RateWorkouts.vue"),
  },
  {
    path: "/bewerten/anamnese/:anamnese_id",
    name: "RateAnamnese",
    component: () => import(/* webpackChunkName: "einmalig" */ "@/views/einmalig/RateAnamnese.vue"),
  },
  {
    path: "/devices",
    name: "DeviceList",
    component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceList.vue"),
    children: [
      {
        path: "create",
        name: "DeviceCreate",
        component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceForm.vue"),
        children: [
          {
            path: "exercise/create",
            name: "DeviceExerciseCreate",
            component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceExerciseForm.vue"),
          },
        ],
      },
      {
        path: ":id",
        name: "DeviceEdit",
        component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceForm.vue"),
        children: [
          {
            path: "exercise/create",
            name: "DeviceExerciseCreate",
            component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceExerciseForm.vue"),
          },
          {
            path: "exercise/:eid",
            name: "DeviceExerciseEdit",
            component: () => import(/* webpackChunkName: "deviceManagement" */ "@/views/deviceManagement/deviceExerciseForm.vue"),
          },
        ],
      },
    ],
  },
]
